
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='ui stackable grid receipe'>
  <div className='ui sixteen wide column c'>
    Kichererbsencurry mit Karotten und Minzjoghurt
  </div>
  <div className='ui six wide column a'>1 rote Zwiebel</div>
  <div className='ui ten wide column b'>und</div>
  <div className='ui six wide column a'>1 cm Ingwer</div>
  <div className='ui ten wide column b'>schälen und fein würfeln.</div>
  <div className='ui six wide column a'>1 kg Karotten</div>
  <div className='ui ten wide column b'>
    schälen und in Scheiben schneiden. Alles in
  </div>
  <div className='ui six wide column a'>2 EL Rapsöl</div>
  <div className='ui ten wide column b'>anbraten. Mit</div>
  <div className='ui six wide column a'>750 g stückigen Tomaten</div>
  <div className='ui ten wide column b'>aufgiessen.</div>
  <div className='ui six wide column a'>340 g gekochte Kichererbsen</div>
  <div className='ui ten wide column b'>abspülen und zum Gemüse geben. Mit</div>
  <div className='ui six wide column a'>1 TL Kurkumapulver</div>
  <div className='ui ten wide column b'>und</div>
  <div className='ui six wide column a'>1 TL gemahlenem Kreuzkümmel</div>
  <div className='ui ten wide column b'>und</div>
  <div className='ui six wide column a'>Chilipulver</div>
  <div className='ui ten wide column b'>und</div>
  <div className='ui six wide column a'>Salz</div>
  <div className='ui ten wide column b'>würzen.</div>
  <div className='ui sixteen wide column c'>Für den Minzjoghurt</div>
  <div className='ui six wide column a' />
  <div className='ui ten wide column b'>Von</div>
  <div className='ui six wide column a'>2 Stielen Minze</div>
  <div className='ui ten wide column b'>
    die Blätter abzupfen, hacken und mit
  </div>
  <div className='ui six wide column a'>200 g Joghurt</div>
  <div className='ui ten wide column b'>und</div>
  <div className='ui six wide column a'>1 Messerspitze Zimt</div>
  <div className='ui ten wide column b'>würzen.</div>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;